// extracted by mini-css-extract-plugin
export default {"root":"ChatSettingsPage_root__DjGXo","panel":"ChatSettingsPage_panel__rZzBk","divider":"ChatSettingsPage_divider__ASMd2","content":"ChatSettingsPage_content__gPt7H"};